var _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightningDuotoneLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "lets-icons:lightning-duotone-line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4251_2238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 7,
    width: 22,
    height: 34
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1116 26.646L18.8716 26.626C15.8156 26.346 14.2876 26.208 13.8016 25.162C13.3176 24.118 14.1976 22.862 15.9556 20.348L23.1216 10.11C24.2836 8.44998 24.8656 7.61998 25.3676 7.79598C25.8676 7.97398 25.7996 8.98398 25.6676 11.006L25.2596 17.104C25.1356 18.944 25.0756 19.864 25.6036 20.484C26.1336 21.104 27.0516 21.186 28.8876 21.354L29.1276 21.374C32.1836 21.654 33.7116 21.792 34.1976 22.838C34.6816 23.882 33.8016 25.138 32.0416 27.652L24.8776 37.89C23.7156 39.55 23.1336 40.38 22.6316 40.204C22.1316 40.026 22.1996 39.016 22.3316 36.994L22.7396 30.896C22.8636 29.056 22.9236 28.136 22.3956 27.516C21.8656 26.896 20.9476 26.814 19.1116 26.646Z",
    stroke: "white"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4251_2238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 0H48V48H0V0Z",
    fill: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37 8L34 12H38L35 16M13 32L10 36H14L11 40",
    stroke: "#2CE100",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningDuotoneLine);
export default __webpack_public_path__ + "static/media/lightning-duotone-line.d359524c52c16a9b3fc5c62cba1c7147.svg";
export { ForwardRef as ReactComponent };